import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getListInternalDocsFailed,
  getListInternalDocsStart,
  getListInternalDocsSuccess,
} from "../redux/getListInternalDocs";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { getListInteralDocsApi } from "core/http/service/internalDocument";
import { SCREEN } from "helper/roleChecker/Screens";
import { formSearchSelectorDataSelector } from "../redux/selector";
import { mapValues, omit } from "lodash";
import { transformDate } from "helper/utils";

function* getListInternalDocsWork(
  action: ReturnType<typeof getListInternalDocsStart>
) {
  const id =
    action.payload.type === "outstanding"
      ? "outstanding"
      : (action.payload.type ?? null);
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(id));
  const form = yield select(formSearchSelectorDataSelector);
  const searchValue = mapValues(omit(form, ["isSearching"]), transformDate);
  const params = { offset, limit, ...searchValue, ...action.payload.params };
  try {
    const res = yield call(getListInteralDocsApi, {
      params,
      screenCode: SCREEN.IP_012,
    });

    yield put({
      type: getListInternalDocsSuccess.type,
      payload: {
        type: action.payload.type,
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListInternalDocsFailed.type,
      payload: {
        type: action.payload.type,
      },
    });
  }
}

function* watchGetListInternalDocs() {
  yield takeEvery(getListInternalDocsStart.type, getListInternalDocsWork);
}

export default function* getNewsSaga() {
  yield all([watchGetListInternalDocs()]);
}
